// Built from Mockup-v2/chrome.js for the Shopify theme. Edit the mockup, then rebuild.
var MJA = window.MJA || "";
// Shared site chrome for the mockup. In the Shopify theme these become the header and footer section groups.
(() => {
  const me = document.currentScript;
  const part = me.dataset.part;
  const active = me.dataset.active || '';
  const cur = key => (key === active ? ' aria-current="page"' : '');
  const C = window.MOJOCO;
  const ico = id => `<svg class="ico" aria-hidden="true"><use href="#${id}"/></svg>`;
  const chev = '<svg class="nav-chev" viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
  const HELP = [
    ['/pages/faq', 'i-question', 'FAQ', 'Quick answers'],
    ['/pages/shipping', 'i-truck', 'Track an order', 'Shipping and delivery'],
    ['/pages/returns', 'i-return', 'Returns', '30 days, free'],
    ['/pages/warranty', 'i-shield', 'Warranty', 'Register for 18 months'],
    ['/pages/contact', 'i-chat', 'Contact us', 'We reply by email']
  ];
  const SOCIAL = [
    ['Instagram', 'https://www.instagram.com/mojocohome', '@mojocohome', 'i-heart'],
    ['TikTok', 'https://www.tiktok.com/@mojocohome', '@mojocohome', 'i-play'],
    ['Facebook', 'https://www.facebook.com/profile.php?id=61572309959498', 'MOJOCO Home', 'i-chat'],
    ['Amazon', 'https://www.amazon.com/stores/Mojoco/page/F0EC4E85-D405-4A6D-B2E2-9E6FB1763695', 'MOJOCO store', 'i-box']
  ];
  window.MOJOCO.SOCIAL = SOCIAL;

  const header = `
<div class="nav-shell">
  <nav class="nav${me.dataset.stuck ? ' is-stuck' : ''}" aria-label="Main" data-nav>
    <a class="brand" href="/" aria-label="MOJOCO Home, home page"><img src="${MJA}logo-mark.svg?v=21e62622" alt="MOJOCO" width="118" height="18"></a>
    <ul class="nav-links">
      <li><button class="nav-trigger" type="button" aria-expanded="false" aria-controls="drop-shop" data-drop-btn="shop"${cur('shop')}>Shop${chev}</button></li>
      <li><a href="/pages/reviews"${cur('reviews')}>Reviews</a></li>
      <li><a href="/pages/warranty"${cur('warranty')}>Warranty</a></li>
      <li><button class="nav-trigger" type="button" aria-expanded="false" aria-controls="drop-help" data-drop-btn="help"${cur('help')}>Help${chev}</button></li>
    </ul>
    <div class="nav-tools">
      <a class="icon-btn hide-sm" href="/search" aria-label="Search">${ico('i-search')}</a>
      <a class="icon-btn" href="/cart" aria-label="Cart, ${(window.MJ_SHOP && MJ_SHOP.cart) || 0} items" data-cart>${ico('i-bag')}<span class="cart-count" data-cart-count>${(window.MJ_SHOP && MJ_SHOP.cart) || 0}</span></a>
      <button class="icon-btn nav-menu-btn" type="button" aria-label="Open menu" aria-expanded="false" data-menu-btn>${ico('i-menu')}</button>
    </div>
  </nav>
  <div class="nav-drop" id="drop-shop" data-drop="shop" data-open="false">
    <div class="nd-body">
      <a class="nd-feature" href="${C.url('dryer')}">
        <span class="nd-caps">Best seller</span>
        <b class="nd-title">${C.products.dryer.name}</b>
        ${C.starsHTML(C.products.dryer.rating, 'nd-stars')}
        <span class="nd-pill"><span>${C.priceText(C.products.dryer)}</span>Shop now ${ico('i-arrow')}</span>
        <img class="nd-feature-img" src="${C.products.dryer.cut}" alt="" loading="lazy">
      </a>
      <div class="nd-grid nd-grid-2">
        ${C.order.filter(k => k !== 'dryer').map(k => { const p = C.products[k]; return `<a class="nd-tile nd-prod" href="${C.url(k)}"><span class="nd-img"><img src="${p.cut}" alt="" loading="lazy"></span><span class="nd-txt"><span class="nd-caps">${p.label}</span><b>${p.short}</b><span class="nd-price">${p.isNew ? `${C.priceText(p)} <span class="nd-new">New</span>` : (k === 'washer' ? 'From ' : '') + C.priceText(p)}</span></span></a>`; }).join('')}
      </div>
    </div>
    <div class="nd-foot"><span>${ico('i-truck')}Free shipping</span><span>${ico('i-return')}30-day returns</span><span>${ico('i-shield')}Up to 18-month warranty</span><a href="/#range">See the whole range ${ico('i-arrow')}</a></div>
  </div>
  <div class="nav-drop" id="drop-help" data-drop="help" data-open="false">
    <div class="nd-body">
      <div class="nd-feature nd-feature-help">
        <span class="nd-caps">Help</span>
        <b class="nd-title">We're here to help</b>
        <p>Questions about an order or a product? Write to the MOJOCO team and we'll reply by email.</p>
        <a class="nd-pill" href="/pages/contact"><span>${ico('i-mail')}</span>Contact us ${ico('i-arrow')}</a>
        <div class="nd-social">${SOCIAL.map(x => `<a href="${x[1]}" target="_blank" rel="noopener">${x[0]}</a>`).join('')}</div>
      </div>
      <div class="nd-grid nd-grid-3">
        ${HELP.filter(h => h[0] !== '/pages/contact').concat([['/pages/reviews', 'i-star', 'Reviews', 'What owners say']]).concat([['/#range', 'i-box', 'Shop the range', 'All five products']]).slice(0, 6).map(h => `<a class="nd-tile nd-help" href="${h[0]}"><span class="nd-ico">${ico(h[1])}</span><span class="nd-txt"><b>${h[2]}</b><span>${h[3]}</span></span></a>`).join('')}
      </div>
    </div>
    <div class="nd-foot"><span>${ico('i-truck')}Free shipping</span><span>${ico('i-return')}30-day returns</span><span>${ico('i-shield')}Up to 18-month warranty</span><a href="/pages/faq">Browse all answers ${ico('i-arrow')}</a></div>
  </div>
</div>
<div class="m-menu" data-open="false" data-menu>
  <div class="mm-wrap">
    <span class="mm-caps">Shop</span>
    <div class="mm-grid">
      ${C.order.map(k => { const p = C.products[k]; return `<a class="mm-prod${k === 'dryer' ? ' is-feature' : ''}" href="${C.url(k)}"><span class="mm-pimg"><img src="${p.cut}" alt="" loading="lazy"></span><span class="mm-ptxt"><b>${p.short}</b><span>${p.isNew ? `${C.priceText(p)} · New` : (k === 'washer' ? 'From ' : '') + C.priceText(p)}</span></span></a>`; }).join('')}
      <a class="mm-prod mm-all" href="/#range"><span class="mm-ptxt"><b>See the whole range</b><span>All five products</span></span>${ico('i-arrow')}</a>
    </div>
    <span class="mm-caps">Help</span>
    <div class="mm-list">
      ${[['/pages/reviews', 'i-star', 'Reviews'], ...HELP.map(h => [h[0], h[1], h[2]])].map(h => `<a class="mm-row" href="${h[0]}"><span class="mm-ico">${ico(h[1])}</span>${h[2]}${ico('i-arrow')}</a>`).join('')}
    </div>
    <div class="mm-foot">${SOCIAL.map(x => `<a href="${x[1]}" target="_blank" rel="noopener">${x[0]}</a>`).join('')}</div>
  </div>
</div>`;

  const footer = `
<footer>
  <div class="wrap">
    <div class="foot-signup">
      <div><h3>Fresh care, anywhere.</h3><p>New products and restocks, by email. No spam.</p></div>
      <form class="signup" data-signup novalidate>
        <label for="signup-email">Email address</label>
        <div class="signup-row">
          <input id="signup-email" type="email" placeholder="you@example.com" autocomplete="email" required>
          <button class="btn" type="submit">Subscribe</button>
        </div>
        <p class="signup-msg" data-signup-msg aria-live="polite"></p>
      </form>
    </div>
    <div class="foot-grid">
      <div class="foot-brand"><img src="${MJA}logo-mark.svg?v=21e62622" alt="MOJOCO" width="150" height="23"><p><b class="foot-tag">Fresh care, anywhere.</b>Laundry and home care for apartments, small spaces and travel.</p></div>
      <div><h4>Shop</h4><ul>${C.order.map(k => `<li><a href="${C.url(k)}">${C.products[k].name}</a></li>`).join('')}</ul></div>
      <div><h4>Help</h4><ul><li><a href="/pages/faq">FAQ</a></li><li><a href="/pages/shipping">Shipping &amp; tracking</a></li><li><a href="/pages/returns">Returns</a></li><li><a href="/pages/warranty">Warranty</a></li><li><a href="/pages/contact">Contact us</a></li><li><a href="/pages/reviews">Reviews</a></li></ul></div>
      <div><h4>Follow</h4><ul>${SOCIAL.map(x => `<li><a href="${x[1]}" target="_blank" rel="noopener">${x[0]}</a></li>`).join('')}</ul></div>
    </div>
    <div class="foot-bottom"><span>© 2026 MOJOCO Home</span><span>mojocohome.com</span></div>
  </div>
  <div class="giant" aria-hidden="true"><img src="${MJA}logo-mark.svg?v=21e62622" alt=""></div>
</footer>
<div class="toast" data-toast data-show="false" role="status"><span class="t-ico">${ico('i-check')}</span><span data-toast-text>Added to cart</span></div>
<dialog class="cart-drawer" data-cd aria-labelledby="cd-h">
  <div class="cd-panel">
    <header class="cd-head">
      <h2 id="cd-h">Your cart <span class="cd-count" data-cd-count></span></h2>
      <button class="cd-x" type="button" data-cd-close aria-label="Close cart"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>
    </header>
    <p class="cd-added" data-cd-added role="status" aria-live="polite"></p>
    <div class="cd-body" data-cd-body></div>
    <footer class="cd-foot" data-cd-foot>
      <div class="cd-save" data-cd-save hidden><span>Savings</span><b></b></div>
      <div class="cd-sub"><span>Subtotal</span><b data-cd-sub>$0.00</b></div>
      <p class="cd-note">${ico('i-truck')}Free shipping and 30-day returns. Taxes at checkout.</p>
      <a class="cd-checkout" href="/checkout" data-cd-checkout><svg class="lock" viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg><span>Checkout</span><b data-cd-sub>$0.00</b></a>
      <button class="cd-keep" type="button" data-cd-close>Keep shopping</button>
    </footer>
  </div>
</dialog>`;

  me.insertAdjacentHTML('beforebegin', part === 'footer' ? footer : header);
})();
